<ng-container *ngIf="initialized && dto">

    <div class="flex align-items-center justify-content-between p-3 surface-section border-sm -mx-5 -mt-2 shadow-1 z-1"
    style="position: sticky; top: 60px;">
        <div class="flex align-items-center gap-2 pl-3">
            <i class="fa-regular fa-file-lines text-xl text-primary"></i>
            <h3 class="m-0 text-xl font-medium">{{ dto.name }}</h3>
        </div>
    </div>

    <!-- Single persistent p-splitter — editor is never destroyed on tab switch -->
    <div class="surface-ground mt-3" style="height: calc(100vh - 145px);" [class.te-splitter-resizing]="isSplitterResizing">
        <p-splitter [style]="{'height': '100%'}" [panelSizes]="splitterSizes" [minSizes]="[3, 3]" [step]="15" layout="horizontal"
                    (onResizeStart)="onSplitterResizeStart()" (onResizeEnd)="onSplitterResizeEnd()">

            <!-- LEFT PANEL: content swaps per tab -->
            <ng-template pTemplate>
                <div class="surface-border border-round shadow-1 flex-auto h-full surface-section flex flex-column overflow-hidden">

                    @if (activeNavigationItem?.action === 'Editor') {
                        <!-- Sub-tabs for left panel content -->
                        <p-tabs [value]="activeLeftPanelTabValue" (valueChange)="onLeftPanelTabChange($event)" styleClass="te-left-panel-tabs">
                            <p-tablist>
                                @for (tab of leftPanelTabs; track tab.action; let i = $index) {
                                    <p-tab [value]="'' + i">
                                        <i [class]="tab.icon" class="mr-1"></i>
                                        {{ tab.label }}
                                    </p-tab>
                                }
                            </p-tablist>
                        </p-tabs>

                        <!-- Sub-tab content -->
                        <div class="flex-1 overflow-auto p-3">
                            @switch (activeLeftPanelTab?.action) {
                                @case ('Variablen') {
                                    <mvs-te-variables
                                            *ngIf="dto.id"
                                            [variableProviderService]="crudService"
                                            alias="te.TeTemplateVariable"
                                            attributeName="template"
                                            [contentProviderId]="dto.id"
                                            (onVariableRenamed)="handleVariableRenamed($event)"
                                            (onTableInsert)="handleTableInsert($event)"
                                    ></mvs-te-variables>
                                }
                                @case ('Artefakte') {
                                    <mvs-embedded-artefacts
                                            *ngIf="dto.id"
                                            [templateId]="dto.id"
                                    ></mvs-embedded-artefacts>
                                }
                                @case ('Basisdaten') {
                                    <mvs-widget *ngIf="widgetBasicData" [widgetData]="widgetBasicData"></mvs-widget>
                                }
                            }
                        </div>
                    }

                    @if (activeNavigationItem?.action === 'Testen') {
                        <div class="p-3 h-full overflow-auto">
                            <mvs-te-test-case
                                    [contentProviderId]="dto.id"
                                    [variableProviderServiceInput]="templateVariableService"
                                    [generateFn]="generateTestCaseFn"
                                    [initialTestCaseId]="selectedTestCase?.dto?.id"
                                    (onSelectTestCase)="handleSelectTestCase($event)"
                            ></mvs-te-test-case>
                        </div>
                    }

                </div>
            </ng-template>

            <!-- RIGHT PANEL: persistent editor, never destroyed -->
            <ng-template pTemplate>
                <div class="h-full w-full">
                    <!-- Editor: always alive, hidden only on Testen tab -->
                    <div [hidden]="activeNavigationItem?.action === 'Testen'" class="h-full px-3 mt-2">
                        <div class="surface-section flex-auto h-full border-round">
                            <mvs-te-editor
                                    [variableProviderService]="crudService"
                                    [contentProviderId]="dto.id"
                                    [selectedTestCase]="selectedTestCase"
                                    [content]="dto.content"
                                    [editorTypeEnum]="dto.editorTypeEnum"
                                    [artefactMap]="artefactMap"
                                    [previewEnabled]="false"
                                    [testPreviewHtml]="trustedGenerateResponseHtml"
                                    [testPreviewPdf]="trustedGenerateResponsePdf"
                                    [testPreviewBusy]="busy"
                                    [testPreviewError]="occurredException"
                                    [testPreviewErrorDetails]="occurredExceptionDetails"
                                    (onSave)="handleEditorOnSave($event)"
                                    (onGeneratePreview)="generateDocument()"
                                    [contentType]="dto.contentTypeEnum"
                                    alias="te.TeTemplateVariable"
                                    attributeName="template"
                            ></mvs-te-editor>
                        </div>
                    </div>

                    <!-- Test case setup: shown only on Testen tab -->
                    @if (activeNavigationItem?.action === 'Testen') {
                        <div class="px-3 h-full w-full">
                            <mvs-te-test-case-setup></mvs-te-test-case-setup>
                        </div>
                    }
                </div>
            </ng-template>

        </p-splitter>
    </div>

</ng-container>
